<template>
  <DxDataGrid :hover-state-enabled="true" :show-borders="false" :data-source="props.data" id="teamGridContainer" @initialize="onInitialize"
    :selected-row-keys="selectedKeys" :auto-navigate-to-focused-row="true" key-expr="id" @content-ready="onContentReady" >
    <DxFilterRow :visible="true" />
    <DxHeaderFilter :visible="true" />
    <DxStateStoring :enabled="true" type="localStorage" storage-key="teamGridContainer" />
    <DxColumn data-field="id" data-type="string" caption="ID" :visible="false" />
    <DxColumn data-field="teamName" data-type="string" caption="Name" />
    <DxColumn data-field="service.blServiceName" data-type="string" caption="Service" />
    <DxColumn type="buttons" caption="Actions" :width="70">
      <DxButton hint="Teams" styling-mode="contained" type="normal" @click="showTeam">
        <TeamIcon></TeamIcon>
      </DxButton>      
    </DxColumn>
    <DxPaging :page-size="10" />
    <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" />
  </DxDataGrid>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPaging, DxPager,
  DxHeaderFilter,
  DxStateStoring,
  DxButton
} from "devextreme-vue/data-grid";
import { ServiceTeamItem } from "@/services/entities/ServiceTeams/ServiceTeamItem";
import { configureDataGridColumnsOrder } from "@/common/util";
import TeamIcon from "../util/TeamIcon.vue";


const emit = defineEmits(["detail"]);
const selectedKeys = ref([] as number[]);
const props = defineProps({
  data: { type: Array as () => ServiceTeamItem[], default: () => [] },
});
const gridRef = ref();

let isConfigured = false;

function onInitialize(e: { component: any}) {
  gridRef.value = e.component;
}

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['id', 'teamName', 'service.blServiceName', 'buttons'];
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }
};

function showTeam(e: any) {
    selectedKeys.value = [e.row.data.id];
    emit("detail", e.row.data.id);
}

</script>
<style lang="scss" scoped>
</style>